module.exports = __webpack_public_path__ + "img/entering-the-country-with-a-dog-en.dc3fd609.svg";